import Order from "../../../Models/Order";
import UpdateOrder from "../../../Models/UpdateOrder/UpdateOrder";
import PhoneNumberPicker from "../../../DomUtilities/PhoneNumberPicker";

export default class UpdateCustomer {
	modalDiv: HTMLDivElement;
	order: Order;
	updatedOrder: UpdateOrder;
	saveButton: HTMLButtonElement;
	nameInput: HTMLInputElement;
	phoneInput: HTMLInputElement;
	phonePicker: PhoneNumberPicker;

	constructor(order: Order, updatedOrder: UpdateOrder) {
		this.order = order;
		this.updatedOrder = updatedOrder;
	}

	public init(modal: HTMLDivElement, saveButton: HTMLButtonElement) {
		this.modalDiv = modal;
		this.saveButton = saveButton;
		this.nameInput = this.modalDiv.querySelector('input[name="customerName"]');
		this.phoneInput = this.modalDiv.querySelector('input[name="customerPhoneNumber"]');
		this.phonePicker = new PhoneNumberPicker(this.phoneInput);
		this.phoneInput.readOnly = true;

		this.addInputsEventsListeners();
	}

	private addInputsEventsListeners() {
		this.phonePicker.onUtilsLoad(() => {
			this.phoneInput.readOnly = false;
			this.validatePhone();
		});

		this.phoneInput.addEventListener("countrychange", () => {
			this.validatePhone();
		});

		this.phoneInput.oninput = () => {
			this.validatePhone();
		}

		this.nameInput.onchange = () => {
			const newName = this.nameInput.value.trim();

			if (newName) {
				this.enableSaveButton();
			} else {
				this.disableSaveButton();
			}

			if (newName && newName != this.order.customerName) {
				this.updatedOrder.customerName = newName;
			} else {
				this.updatedOrder.customerName = null;
			}
		}
	}

	private validatePhone() {
		const newPhone = this.phoneInput.value.trim();

		if (this.phonePicker.isValidPhoneNumber()) {
			this.enableSaveButton();
			this.phoneInput.style.borderColor = "#bdbdbd";
		} else {
			this.disableSaveButton();
			this.phoneInput.style.borderColor = "red";
		}

		if (this.phonePicker.isValidPhoneNumber() && this.phonePicker.phoneNumber != this.order.customerPhoneNumber) {
			this.updatedOrder.customerPhoneNumber = this.phonePicker.phoneNumber;
			this.phonePicker.phoneNumber = newPhone;
		} else {
			this.updatedOrder.customerPhoneNumber = null;
		}
	}

	private enableSaveButton() {
		this.saveButton.disabled = false;
		this.saveButton.classList.remove('disabled');
	}

	private disableSaveButton() {
		this.saveButton.disabled = true;
		this.saveButton.classList.add('disabled');
	}
}
